/**
 * Products for the recommendation carousels, in the same order as the requested part numbers.
 *
 * Product search does not keep the requested order, so the priority set in CMC or returned by
 * Emarsys would be lost. Wraps useProducts without changing it, so its other consumers
 * (checkout, wishlist, analytics) are not affected.
 */
import { useProducts } from '@/data/Content/Products';
import { ProductType } from '@/data/types/Product';
import { sortByPartNumberOrder } from '@/data/utils/recommendationOrder';
import { useMemo } from 'react';

type Props = Parameters<typeof useProducts>[0] & { id: string[] };

export const useRecommendationProducts = (props: Props) => {
	const result = useProducts(props);
	const { products } = result;
	const { id } = props;

	const sortedProducts = useMemo(
		() => products && sortByPartNumberOrder(products as ProductType[], id),
		[products, id]
	);

	return { ...result, products: sortedProducts };
};
